import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { ProcessedClaim } from 'src/app/types/datasources/claims.model'
import {
  IncomeInvoiceDto,
  IncomeInvoiceStatus,
  IncomeInvoiceType,
} from 'src/app/types/dto/income-invoice.dto'
import { environment } from 'src/environments/environment'
import { AuthService } from '../auth.service'
import { HttpHelperService } from '../http.service'
import { LogService } from '../log.service'
import { TimedCache } from '../timed-cache'
import { JobLookupApiService } from './job-lookup.api.service'

@Injectable({
  providedIn: 'root',
})
export class ClaimsApiService {
  private httpHelper = inject(HttpHelperService);
  private auth = inject(AuthService);
  private logger = inject(LogService);
  private http = inject(HttpClient);
  private jobLookup = inject(JobLookupApiService);

  private cachedClaims = new TimedCache<ProcessedClaim[]>()

  getClaims(): Observable<ProcessedClaim[]> {
    const comp = this.auth.getCurrentCompany()
    if (!comp) {
      this.logger.log('claims.api', 'getClaims', null, 'no company')
      throw Error('no company set in getClaims')
    }

    return this.cachedClaims.get(comp.id, () => {
      const url = environment.apiUrl + 'income-invoices?forDashboard=true'
      return this.http.get<IncomeInvoiceDto[]>(url, this.httpHelper.httpReadOnlyOptions).pipe(
        map((res) =>
          res.map((c) => {
            return {
              ...c,
              status: IncomeInvoiceStatus[c.incomeInvoiceStatusId],
              type: IncomeInvoiceType[c.incomeInvoiceTypeId],
            }
          })
        ),
        switchMap((claims) => this.jobLookup.enrich(claims))
      )
    })
  }
}
